module.exports = Object.freeze({
    root: 'https://help.pluscards.ru/plus/administrirovanie/nastroika-kompanii',
    broadcaster: 'https://help.pluscards.ru/plus/administrirovanie/avtomatizaciya-aktivnostei',
})
